{
  "version": 1,
  "asset_id": "017d5526-1af8-4fa7-bdc2-b50efcf3d7c8",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/017d5526-1af8-4fa7-bdc2-b50efcf3d7c8/clip-img_1994-poster-sm.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/017d5526-1af8-4fa7-bdc2-b50efcf3d7c8/clip-img_1994-poster-sm.webp",
  "original_filename": "clip-img_1994-poster-sm.webp",
  "size": 17596,
  "content_type": "image/webp",
  "created_at": "2026-08-01T21:10:14Z"
}
